import { Wifi, WifiOff, RefreshCw } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useNetworkStatus } from '@/hooks/useNetworkStatus';
import { useHARStore } from '@/stores/har-store';

export function NetworkStatusIcon() {
  const { isOnline } = useNetworkStatus();
  const { pendingAnalysesCount, retryPendingAnalyses } = useHARStore();

  const hasPending = pendingAnalysesCount > 0;

  if (!isOnline) {
    return (
      <button
        className={cn(
          'btn-ghost p-1.5 sm:p-2 relative group',
          'text-amber-500 hover:text-amber-600 hover:bg-amber-50 dark:hover:bg-amber-500/10'
        )}
        title="Offline mode"
      >
        <WifiOff className="w-4 h-4 sm:w-5 sm:h-5" />
        <span className="absolute -bottom-8 left-1/2 -translate-x-1/2 px-2 py-1 bg-slate-800 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none z-50">
          You're offline
        </span>
      </button>
    );
  }

  if (hasPending) {
    return (
      <button
        onClick={retryPendingAnalyses}
        className={cn(
          'btn-ghost p-1.5 sm:p-2 relative group',
          'text-emerald-500 hover:text-emerald-600 hover:bg-emerald-50 dark:hover:bg-emerald-500/10 animate-pulse'
        )}
        title={`${pendingAnalysesCount} pending analysis${pendingAnalysesCount > 1 ? 'es' : ''} - Click to retry`}
      >
        <RefreshCw className="w-4 h-4 sm:w-5 sm:h-5" />
        <span className="absolute -top-1 -right-1 w-4 h-4 bg-emerald-500 text-white text-[10px] font-bold rounded-full flex items-center justify-center">
          {pendingAnalysesCount}
        </span>
        <span className="absolute -bottom-8 left-1/2 -translate-x-1/2 px-2 py-1 bg-slate-800 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none z-50">
          {pendingAnalysesCount} pending - Click to retry
        </span>
      </button>
    );
  }

  // Online with no pending - show subtle indicator
  return (
    <div
      className="btn-ghost p-1.5 sm:p-2 text-slate-400 hover:text-slate-500 relative group cursor-default"
      title="Online"
    >
      <Wifi className="w-4 h-4 sm:w-5 sm:h-5" />
      <span className="absolute -bottom-8 left-1/2 -translate-x-1/2 px-2 py-1 bg-slate-800 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none z-50">
        Online
      </span>
    </div>
  );
}
